import React, { PureComponent } from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import messages from './messages';
import css from './index.scss';
import DefaultCourseMapperAdmin from '../default-course-mapper-admin/index';
import ViewCourseModal from './modals/view-course';
import withLoader from '../with-loader';

class ManageCourse extends PureComponent {
    render() {
        const { intl,
            isDefaultCoursesLoaded,
            defaultCourses,
            savingDefaultCourses,
            handleOnSave,
            showCourseDetails,
            hideCourseDetails,
            isCourseModalVisible,
            courseDetails,
            selectedProduct,
            deselectCourses,
            upfCourses
        } = this.props;
        const mapperProps = {
            showCourseDetails
        };

        const content = !isDefaultCoursesLoaded ? (<div />) :
            (<div>
                <div>
                    <DefaultCourseMapperAdmin
                        defaultCourses={defaultCourses}
                        deselectCourses={deselectCourses}
                        handleOnSave={handleOnSave}
                        savingDefaultCourses={savingDefaultCourses}
                        selectedProduct={selectedProduct}
                        upfCourses={upfCourses}
                        {...mapperProps}
                    />

                    <ViewCourseModal
                        courseDetails={courseDetails}
                        onClose={hideCourseDetails}
                        show={isCourseModalVisible} />
                </div>
            </div>);

        return (<div>
            <div className={css.header}>
                <div className={css.mainHeading}>
                    <div className={css.title}>{intl.formatMessage(messages.pageTitle)}</div>
                </div>
                <div className={css.subHeading}>
                    <span> {intl.formatMessage(messages.pageSubTitle)} </span>
                </div>
            </div>
            {content}
        </div>);
    }
}

ManageCourse.propTypes = {
    intl: intlShape.isRequired,
    isDefaultCoursesLoaded: PropTypes.bool,
    defaultCourses: PropTypes.arrayOf(PropTypes.object),
    savingDefaultCourses: PropTypes.bool,
    handleOnSave: PropTypes.func,
    selectedProduct: PropTypes.object,
    showCourseDetails: PropTypes.func,
    hideCourseDetails: PropTypes.func,
    isCourseModalVisible: PropTypes.bool,
    courseDetails: PropTypes.object,
    deselectCourses: PropTypes.func,
    upfCourses: PropTypes.arrayOf(PropTypes.object)
};

ManageCourse.defaultProps = {
    upfCourses: []
};

const ManageCourseWithDataLoader = withLoader('fetching')(ManageCourse);
export default injectIntl(styleable(css)(ManageCourseWithDataLoader));



// WEBPACK FOOTER //
// ./app/components/manage-course/index.js